import styled from 'styled-components';
import Text from '@text';
import themedColor, {
  ThemedColorReturn
} from '../../../styles/theme/themed-color';
import styleUtils from '../../../styles/style.utils';
import themedFontSize from '../../../styles/theme/themed-font-size';

interface ContainerProps {
  bgColor: 'GRAY' | 'WHITE';
}

const Container = styled.div<ContainerProps>`
  background: ${({ bgColor }: ContainerProps): ThemedColorReturn =>
    themedColor(bgColor)};
  width: 100%;
  padding: ${styleUtils.px(36)};
  display: flex;
  flex: 1 0 auto;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  button {
    background: ${themedColor('BUTTON_BG')};
    border-color: ${themedColor('BUTTON_BORDER')};
    color: ${themedColor('BUTTON_TEXT')};

    p {
      color: ${themedColor('BUTTON_TEXT')};
    }
  }
`;

const Header = styled(Text)`
  &.ucf-paragraph {
    font-size: ${themedFontSize('BODY')};
    color: ${themedColor('TEXT_BLUE')};
    margin-bottom: ${styleUtils.px(14)};
    margin-left: 0;
    padding: 0;
    font-weight: 600;
    text-align: center;
  }
`;

const StyledText = styled(Text)`
  &.ucf-paragraph {
    font-size: ${themedFontSize('FORM')};
    color: ${themedColor('TEXT_BLUE')};
    margin: 0;
    padding: 0;
    text-align: center;
  }
`;

const PhoneContainer = styled.div`
  display: flex;
  flex-direction: row;
  color: ${themedColor('TEXT_BLUE')};
  text-align: center;

  a.ucf-link {
    text-decoration: none;
    cursor: pointer;
    font-weight: 600;
    color: ${themedColor('TEXT_BLUE')};
    margin-left: ${styleUtils.px(8)};

    &:hover {
      text-decoration: underline;
    }
  }
`;

const ContactIcon = styled.img`
  width: ${styleUtils.px(64)};
  height: ${styleUtils.px(64)};
  margin-bottom: ${styleUtils.px(14)};
`;

const FooterComponents = {
  Container,
  PhoneContainer,
  ContactIcon,
  StyledText,
  Header
};

export default FooterComponents;
